import React from "react";

export const OsIconWindows = (props: { color?: string }): JSX.Element => {
    const color = props.color ?? "#606060";
    return (
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_655_17392)">
                <path
                    d="M0 5.68424V2.36843L3.88233 1.53474V5.6274L0 5.68424ZM11 0V5.52641L4.52951 5.62115V1.39586L11 0ZM0 6.31576L3.88233 6.3726V10.6737L0 9.94742V6.31576ZM11 6.47378V12.0002L4.52951 10.7938V6.37279L11 6.47378Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_655_17392">
                    <rect width="11" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
